export enum Days {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
}

export type DayPreferences = Record<Days, boolean>;

export const DayTimePreferenceKeys = Object.freeze({
  morningAvailability: 'morningAvailability',
  middayAvailability: 'middayAvailability',
  eveningAvailability: 'eveningAvailability',
});
export type DayTimePreferenceKey = keyof typeof DayTimePreferenceKeys;

export type TimePreferences = Record<DayTimePreferenceKey, boolean | null | undefined>;

export type AvailabilityPreferences = {
  spacesAvailable: string | null | undefined;
  leadTimeDays: number | null | undefined;
} & DayPreferences &
  TimePreferences;
